export const enum PrizmRangeState {
  Start = `start`,
  End = `end`,
  Single = `single`,
}
